module.exports = __webpack_public_path__ + "static/media/progressBarGold.7a542637.svg";